<div class="mh-main" [style.margin-top.px]="iosInsetPadding">
  @if (!headerConfig().hideAllNavs) {
    <mh-navbar [iosInsetPadding]="iosInsetPadding" />
  }

  <div class="container-xl p-xl-0 mh-content flex-fill" [style.--mh-navbar-height.px]="contentOffset()">
    <router-outlet />
    <mh-toast-notification></mh-toast-notification>
  </div>

  @if (!headerConfig().hideFooter) {
    <mh-footer></mh-footer>
  }
</div>
